export const mapIotCallingToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
  }));

  return result;
};

export const iotCallingColumns = [
  { key: "phoneNumber", label: "Phone Number", align: "center" },
  { key: "name", label: "Name", align: "center" },
];
